module.exports = __webpack_public_path__ + "static/img/delete_p.a69da375.png";